(function ($) {
  Drupal.behaviors.dw_cc_carousel_formatter_mob_v2 = {
    attach: function (context) {
      $('.js-dwcc-carousel__v2', context).once(function () {
        /*
        /--------------------------------------------------------------------------
        / Set the context for the carousel.
        / Remove the additional wrapper contents on the carousel content-blocks to
        / prevent styling issues.
        /--------------------------------------------------------------------------
        */
        var context = $('.js-dwcc-carousel__v2');
        var extraElements = context.find('.node.node-elc-nodeblock, .content, div:not([class])');

        extraElements.contents().unwrap();

        /*
        /--------------------------------------------------------------------------
        / Strip any whitespace to prevent spaces between slides.
        /--------------------------------------------------------------------------
        */
        var stripWhiteSpace = context.find('*');

        stripWhiteSpace.contents().filter(function () {
          return this.nodeType = Node.TEXT_NODE && /\S/.test(this.nodeValue) === false;
        }).remove();

        /*
        /--------------------------------------------------------------------------
        / Calculate the number of slides.
        /--------------------------------------------------------------------------
        */
        var pagCarouselWrapper = context.find('.js-dwcc-carousel__pagWrapper');
        var carouselWrapper = context.find('.js-dwcc-carousel__carouselWrapper');
        var slideTotal = (carouselWrapper.children().length + carouselWrapper.find('.js-dwcc-carousel__carouselInner').children().length) - 1;
        var slideTotalPerc = (slideTotal * 100) + '%';

        context.find('.js-dwcc-carousel__carouselWrapper').css('width', slideTotalPerc);

        /*
        /--------------------------------------------------------------------------
        / Calculate the width of each slide according to no. of slides.
        /--------------------------------------------------------------------------
        */
        var slideWidth = (100 / slideTotal) + '%';

        context.find('.js-dwcc-carousel__slide_v2').css('width', slideWidth);

        /*
        /--------------------------------------------------------------------------
        / Grab the pagination divs from each slide & append them to the pagination container.
        / Add identifying classes.
        / Apply the selected class to the first pagination element.
        /--------------------------------------------------------------------------
        */
        var paginationElems = context.find('.js-dwcc-carousel__carouselInner').find('div.js-dwcc-carousel__slide_v2 .js-dwcc-carousel__slidePag');

        paginationElems.each(function (i) {
          $(this).detach().appendTo('.js-dwcc-carousel__pagWrapper .js-dwcc-carousel__carouselInner');
          $(this).addClass('js-dw_cc_slide_pag_' + (i + 1));
        });
        context.find('.js-dwcc-carousel__carouselInner .js-dw_cc_slide_pag_1').addClass('selected').next().addClass('next_pag');
        context.find('.js-dwcc-carousel__carouselInner').find('.js-dwcc-carousel__slidePag').eq(-1).addClass('previous_pag');

        /*
        /--------------------------------------------------------------------------
        / Add identifying classes to the slides.
        /--------------------------------------------------------------------------
        */
        context.find('.js-dwcc-carousel__carouselInner .js-dwcc-carousel__slide_v2').each(function (i) {
          $(this).addClass('js-dwcc-carousel__slide' + (i + 1));
        });

        /*
        /--------------------------------------------------------------------------
        / Handle the placeholder slides.
        /--------------------------------------------------------------------------
        */
        // Slide carousel
        var firstSlide = context.find('.js-dwcc-carousel__slideFirst').clone();
        var secondSlide = context.find('.js-dwcc-carousel__slideFirst').next().clone();
        var secondLastSlide = context.find('.js-dwcc-carousel__slideLast').prev().clone();
        var lastSlide = context.find('.js-dwcc-carousel__slideLast').clone();

        if (firstSlide.length || lastSlide.length) {
          var firstSlideContent, secondSlideContent, secondLastSlideContent, lastSlideContent;

          firstSlideContent = context.find('.js-dwcc-carousel__holderFirst').append(firstSlide);
          secondSlideContent = context.find('.js-dwcc-carousel__holderSecond').append(secondSlide);
          secondLastSlideContent = context.find('.js-dwcc-carousel__holder_secondLast').append(secondLastSlide);
          lastSlideContent = context.find('.js-dwcc-carousel__holderLast').append(lastSlide);
          var resetWidth = '100%';

          firstSlideContent.find('.js-dwcc-carousel__slide_v2').css('width', resetWidth);
          secondSlideContent.find('.js-dwcc-carousel__slide_v2').css('width', resetWidth);
          secondLastSlideContent.find('.js-dwcc-carousel__slide_v2').css('width', resetWidth);
          lastSlideContent.find('.js-dwcc-carousel__slide_v2').css('width', resetWidth);
        }
        context.find('.js-dwcc-carousel__slideFirst').addClass('active');

        // Pagination carousel
        var cloneElem = context.find('.js-dwcc-carousel__carouselInner').find('.js-dwcc-carousel__slidePag');
        var firstSlidePag = cloneElem.eq(0).clone();
        var secondSlidePag = cloneElem.eq(1).clone();
        var thirdSlidePag = cloneElem.eq(2).clone();
        var fourthSlidePag = cloneElem.eq(3).clone();
        var fourthLastSlidePag = cloneElem.eq(-4).clone();
        var thirdLastSlidePag = cloneElem.eq(-3).clone();
        var secondLastSlidePag = cloneElem.eq(-2).clone();
        var lastSlidePag = cloneElem.eq(-1).clone();

        context.find('.js-dwcc-carousel__pagHolder').last().append(firstSlidePag, secondSlidePag, thirdSlidePag, fourthSlidePag);
        context.find('.js-dwcc-carousel__pagHolder').first().append(fourthLastSlidePag, thirdLastSlidePag, secondLastSlidePag, lastSlidePag);

        /*
        /--------------------------------------------------------------------------
        / Global vars for calculating slide/pagination animation values.
        /--------------------------------------------------------------------------
        */
        var innerSlideTotal = context.find('.js-dwcc-carousel__carouselInner').children().length;
        var pagCount = slideTotal - 4;
        var isAnimating, pagAnimating, goingLeft, goingRight;

        isAnimating = pagAnimating = goingLeft = goingRight = false;
        var theDirection, pagCarouselDirection;
        var counter = 0;
        var slideDivide = slideTotal / slideTotal;
        var resetRight = -pagCount;
        var resetLeft = slideDivide;
        var counterRight = slideDivide - 1;
        var counterLeft = -(slideTotal - 5);
        var marginResetLeft = -((pagCount + 1) * 100) + '%';
        var marginResetRight = -((slideDivide + 1) * 100) + '%';
        var chevronVal = context.find('.js-dwcc-carousel__carouselnav').length;
        var baseMarginVal = 115.85;
        var increment = 36.85;
        var directionIncrement = 100;
        var resetVal = -(baseMarginVal + (increment * (innerSlideTotal / 2 - 1)));
        var carouselSpeed = 600;

        /*
        /--------------------------------------------------------------------------
        / Handle the slide/pagination carousel animations.
        /--------------------------------------------------------------------------
        */
        // Add active class to the active slide.
        function activeNext() {
          context.find('.js-dwcc-carousel__slide_v2.active').next().addClass('active').siblings().removeClass('active');
        }

        function activePrev() {
          context.find('.js-dwcc-carousel__slide_v2.active').prev().addClass('active').siblings().removeClass('active');
        }

        function switchActive(slide1, slide2) {
          context.find('.js-dwcc-carousel__carouselInner .js-dwcc-carousel__slide_v2' + slide1 + '.active').siblings('.js-dwcc-carousel__carouselInner .js-dwcc-carousel__slide_v2' + slide2).addClass('active').siblings().removeClass('active');
        }

        // Check for RTL
        var isRTL = false;

        setTimeout(function () {
          if ($('.field-content').hasClass('pcl_rtl')) {
            isRTL = true;
          }
        }, 1000);

        // Determine direction (RTL support)
        function negDirection() {
          theDirection = '-=' + directionIncrement + '%';
          counter--;
          goingRight = true;
          goingLeft = false;
          pagCarouselDirection = '-=' + increment + '%';
        }
        function posDirection() {
          theDirection = '+=' + directionIncrement + '%';
          counter++;
          goingRight = false;
          goingLeft = true;
          pagCarouselDirection = '+=' + increment + '%';
        }

        // Determine which functions to be called once
        // rtl value has been gathered.
        function rtlCheck(arrowNo) {
          if (arrowNo === 1) {
            if (isRTL) {
              negDirection();
            } else {
              posDirection();
            }
          } else {
            if (isRTL) {
              posDirection();
            } else {
              negDirection();
            }
          }
        }

        // Determing whether to call activeNext or activePrev.
        function whichDirection() {
          if (goingRight) {
            activeNext();
          } else if (goingLeft) {
            activePrev();
          }
        }

        // Handle the next/previous pagination selection.
        function addPagClasses(currentPag, pagNum) {
          context.find('.js-dwcc-carousel__slidePag').removeClass('selected next_pag previous_pag');
          currentPag.addClass('selected');
          currentPag.next().addClass('next_pag');
          currentPag.prev().addClass('previous_pag');
          if (pagNum === slideDivide) {
            context.find('.js-dw_cc_slide_pag_' + pagCount).addClass('previous_pag');
          } else if (pagNum === pagCount) {
            context.find('.js-dw_cc_slide_pag_' + slideDivide).addClass('next_pag');
          }
        }

        // Animating the pagination carousel.
        function movePagWrapper() {
          pagCarouselWrapper.animate({
            marginLeft: pagCarouselDirection
          }, carouselSpeed, 'easeInOutQuad', function () {
            if (counter === resetRight) {
              pagCarouselWrapper.css({
                'margin-left': ''
              });
            } else if (counter === resetLeft) {
              pagCarouselWrapper.css({
                'margin-left': resetVal + '%'
              });
            }
            pagAnimating = false;
          });
        }

        // Animating the slide carousel.
        function moveCarouselWrapper() {
          carouselWrapper.animate({
            marginLeft: theDirection
          }, carouselSpeed, 'easeInOutQuad', function () {
            whichDirection();
            if (counter === resetRight) {
              carouselWrapper.css({
                'margin-left': marginResetRight
              });
              counter = counterRight;
              switchActive('Last', 'First');
            } else if (counter === resetLeft) {
              carouselWrapper.css({
                'margin-left': marginResetLeft
              });
              counter = counterLeft;
              switchActive('First', 'Last');
            }
            var equivalentPagNum = 1 - counter;

            context.find('.js-dwcc-carousel__slidePag').removeClass('selected next_pag previous_pag');
            var equivalentPag = context.find('.js-dw_cc_slide_pag_' + equivalentPagNum);

            equivalentPag.addClass('selected');
            equivalentPag.next().addClass('next_pag');
            equivalentPag.prev().addClass('previous_pag');

            if (equivalentPagNum === slideDivide) {
              context.find('.js-dw_cc_slide_pag_' + pagCount).addClass('previous_pag');
            } else if (equivalentPagNum === pagCount) {
              context.find('.js-dw_cc_slide_pag_' + slideDivide).addClass('next_pag');
            }
            isAnimating = false;
          });
        }

        // Slide carousel event.
        function animateCarousel(arrowNo) {
          context.find('.js-dwcc-carousel__carouselnav_' + arrowNo).click(function () {
            if (isAnimating === false) {
              isAnimating = true;
              rtlCheck(arrowNo);
              movePagWrapper();
              moveCarouselWrapper();
            }
          });
        }
        for (var j = 1; j <= chevronVal; j++) {
          animateCarousel(j);
        }

        // Pagination carousel event.
        function animatePagination(pagNum) {
          var currentPag = context.find('.js-dw_cc_slide_pag_' + pagNum);
          var pagDir;

          currentPag.click(function () {
            if (!$(this).hasClass('selected')) {
              if ($(this).hasClass('next_pag')) {
                pagDir = 'next_pag';
              } else if ($(this).hasClass('previous_pag')) {
                pagDir = 'previous_pag';
              }
              if (pagAnimating === false) {
                pagAnimating = true;
                addPagClasses(currentPag, pagNum);
                if (pagDir === 'next_pag') {
                  context.find('.js-dwcc-carousel__carouselnav_2').trigger('click');
                } else {
                  context.find('.js-dwcc-carousel__carouselnav_1').trigger('click');
                }
              }
            }
          });
        }
        for (var i = 1; i <= pagCount; i++) {
          animatePagination(i);
        }

        /*
        /--------------------------------------------------------------------------
        / Handle the Carousel animation on mobile.
        /--------------------------------------------------------------------------
        / Add the library 'jQuery_Mob_Touch' to the inc file for this template.
        */
        context.find('.js-dwcc-carousel__carouselWrapper, .js-dwcc-carousel__pagWrapper').swiperight(function () {
          context.find('.js-dwcc-carousel__carouselnav_1').trigger('click');
        });
        context.find('.js-dwcc-carousel__carouselWrapper, .js-dwcc-carousel__pagWrapper').swipeleft(function () {
          context.find('.js-dwcc-carousel__carouselnav_2').trigger('click');
        });
      });
    }
  };
})(jQuery);
